import React, {
  Suspense,
  Fragment,
  useContext,
  useState,
  useRef,
  useEffect,
  useLayoutEffect

} from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { routesKms } from "./routes";
import PageLoading from "../src/component/PageLoading";
import { ThemeProvider } from "@material-ui/core";
import { createCustomTheme } from "./theme";
import AuthProvider, { AuthContext } from "./context/Auth";
import SessionUpdateModal from "./component/SessionUpdateModal";
import { useNavigate } from "react-router-dom";

const theme = createCustomTheme();
const userLoginEmail = localStorage.getItem("user_email");

function RenderRoutes({ data }) {
  return (
    <Suspense fallback={<PageLoading />}>
      <Routes>
        {data.map((route, i) => {
          const Component = route.component;
          const Layout = route.layout || Fragment;

          return (
            <Route
              key={i}
              path={route.path}
              element={
                <Layout>
                  {route.routesKms ? (
                    <RenderRoutes data={route.routesKms} />
                  ) : (
                    <Component />
                  )}
                </Layout>
              }
            />
          );
        })}
      </Routes>
    </Suspense>
  );
}

function AppContent() {
  const { setSessionLogout, setContinueUser, setOpen, open, continueUser } =
    useContext(AuthContext);
  const navigate = useNavigate();

  const user_email = localStorage.getItem("user_email");

  const timerRef = useRef(null);
  const countRef = useRef(0);

  const handleClickOpen = () => setOpen(true);

  const logoutSession = () => {
    setSessionLogout(true);
    setOpen(false);
    countRef.current = 0;
    clearInterval(timerRef.current);
  };

  const SessionUpdateFun = () => {
    setContinueUser(true);
    setOpen(false);
    countRef.current = 0;
  };

  const startTimer = () => {
    clearInterval(timerRef.current);
    // use a ref for counting to avoid re-rendering every second
    timerRef.current = setInterval(() => {
      countRef.current += 1;

      if (countRef.current === 1500) {
        handleClickOpen();
      }

      if (countRef.current === 1800 && open) {
        setSessionLogout(true);
        setOpen(false);
        countRef.current = 0;
      }
    }, 1000);
  };

  const handleUserInteraction = () => {
    if (!open) {
      countRef.current = 0;
    }
  };

  useEffect(() => {
    if (!user_email) return;

    startTimer();

    window.addEventListener("keydown", handleUserInteraction);
    window.addEventListener("mousemove", handleUserInteraction);
    window.addEventListener("click", handleUserInteraction);

    return () => {
      clearInterval(timerRef.current);
      window.removeEventListener("keydown", handleUserInteraction);
      window.removeEventListener("mousemove", handleUserInteraction);
      window.removeEventListener("click", handleUserInteraction);
    };
  }, [open, user_email]);

  useEffect(() => {
    if (!user_email) return;

    if (continueUser) {
      countRef.current = 0;
      startTimer();
      setContinueUser(false);
    }
  }, [continueUser, user_email]);

  // countRef handles thresholds inside the interval; no state-driven effect needed

  const filteredRoutes = routesKms.filter((route) => {
    if (route.guard && !user_email) return false;
    return true;
  });

  return (
    <>
      <SessionUpdateModal
        open={open}
        setOpen={setOpen}
        logoutSession={logoutSession}
        SessionUpdateFun={SessionUpdateFun}
      />
      <RenderRoutes data={filteredRoutes} />
    </>
  );
}

function App() {
  return (
    <ThemeProvider theme={theme}>
      <BrowserRouter>
        <AuthProvider>
          <AppContent />
        </AuthProvider>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
